import reduxStore from "../../configureEnvStore";
import { CALL_BODY_SCREEN, RECORDING } from "../../constants/Constants";
import { NOTIFICATION_TYPES } from "../../constants/DataTrackNotificationConstants";
import { GLOBAL_MEETING_DATA, PublicVariables } from "../../constants/PublicVariables";
import Localize from "../../locale/Localize";
import { handleStopRecording } from "../../actions/recordingAction";
import {
    setRecordInProcess,
    setRecordingBtnEnabled,
    setRecordingErrorView,
    setRecordingInfoOnLoad,
    setRecordingON,
    setStartRecReceived,
} from "../../reducers/recording-reducer";
import { LogFirebase } from "../../services/firestore";
import uploadFilesService from "../../services/uploadFilesService";
import { sendStopRecordingMsg } from "../../shared/dataTrackFunction";
import { initialRecordingOff } from "../../shared/utility";
import CustomToast from "../UI/customToast";

const STATUS = {
    REC_INITIALIZE: "1",
    REC_STRAT: "2",
};

export const isRecordingButtonAvailable = () => {
    return GLOBAL_MEETING_DATA.isAgent && getRecordingFeatureFlagValue() == RECORDING.INITOFF;
};

export const getRecordingFeatureFlagValue = () => {
    return PublicVariables.featureFlag?.SHOWMERECORD;
};

export const showRecordingDisableBtn = (isRemoteParticipantJoined, recordingBtnEnabled, currentCallBodyScreen) => {
    if (GLOBAL_MEETING_DATA.isAgent) {
        if (uploadFilesService.isUploadFilesView() || currentCallBodyScreen === CALL_BODY_SCREEN.NOTIFY_SCREEN) {
            return true;
        }

        if (recordingBtnEnabled && !isRemoteParticipantJoined && getRecordingFeatureFlagValue() === RECORDING.INITOFF) {
            return true;
        }

        return !recordingBtnEnabled;
    }

    return true;
};

export const showRecordingTooltip = (isRemoteParticipantJoined, recordingBtnEnabled, recordingON) => {
    if (GLOBAL_MEETING_DATA.isAgent && recordingBtnEnabled && isRemoteParticipantJoined) {
        return recordingON ? "StopRec" : "StartRec";
    }
};

export const showCallRecordingMessage = () => {
    const { recordingInfoOnLoad } = reduxStore.getState().recording;
    if (recordingInfoOnLoad) {
        if (GLOBAL_MEETING_DATA.isAgent) {
            closeRecordingInfo(false);
        } else {
            CustomToast.success(Localize[PublicVariables.currentLanguageObj.languageCode]["show_recording_for_training_purpose"]);
            reduxStore.dispatch(setRecordingInfoOnLoad(false));
        }
    }
};

let recordingInfoTimer = null;
export const closeRecordingInfo = (forced) => {
    if (forced) {
        setTimeout(() => {
            clearTimeout(recordingInfoTimer);
            reduxStore.dispatch(setRecordingInfoOnLoad(false));
        }, 1000);
    } else {
        recordingInfoTimer = setTimeout(() => {
            /**hide the recording info popup after 15seconds */
            if (getRecordingFeatureFlagValue() == RECORDING.INITOFF) {
                setTimeout(() => {
                    clearTimeout(recordingInfoTimer);
                    reduxStore.dispatch(setRecordingInfoOnLoad(false));
                }, 1000);
            }
        }, 15000);
    }
};

export const handleRecordingStartDatatrackMessage = (msg) => {
    const { recordingON, startRecReceived, recordingErrorView, recordingInfoOnLoad } = reduxStore.getState().recording;

    if (!startRecReceived && !recordingErrorView) {
        if (msg.status == STATUS.REC_INITIALIZE) {
            if (!recordingON) {
                reduxStore.dispatch(setRecordInProcess(true));
                LogFirebase("Recording", "prepareViewShown", "");
            }
        }
        if (msg.room_name && msg.room_name != "") {
            reduxStore.dispatch(setStartRecReceived(true));
            reduxStore.dispatch(setRecordInProcess(false));
            reduxStore.dispatch(setRecordingON(true));
            reduxStore.dispatch(setRecordingInfoOnLoad(true));
            reduxStore.dispatch(setRecordingErrorView(false));
            if (initialRecordingOff() || recordingInfoOnLoad) {
                showCallRecordingMessage();
            }
        }
    }
};

export const handleRecordingStoppedDatatrackMessage = (msg) => {
    reduxStore.dispatch(setStartRecReceived(false));
    hideRecordingErrorView();
    reduxStore.dispatch(setRecordingON(false));
    reduxStore.dispatch(setRecordingInfoOnLoad(false));
    reduxStore.dispatch(setRecordInProcess(false));
    CustomToast.success(Localize[PublicVariables.currentLanguageObj.languageCode]["recording_stopped"]);
};

export const checkIsRecoridngIsStarted = () => {
    const { recordingON } = reduxStore.getState().recording;
    if (GLOBAL_MEETING_DATA.isAgent && recordingON && initialRecordingOff()) {
        reduxStore.dispatch(setRecordingBtnEnabled(false));
        sendStopRecordingMsg();
        reduxStore.dispatch(handleStopRecording());
    }
};

export const handleRecordingErrorOnGuest = (msg) => {
    if (msg.notification_type == NOTIFICATION_TYPES.RECORDING.START_ERROR) {
        CustomToast.error(Localize[PublicVariables.currentLanguageObj.languageCode]["error_recording_please_try_again"]);
        handleFlagsOnRecFail();
    }
};

/* handle falgs for recording fail */
export const handleFlagsOnRecFail = () => {
    reduxStore.dispatch(setRecordInProcess(false));
    reduxStore.dispatch(setStartRecReceived(false));
};

export const hideRecordingErrorView = () => {
    reduxStore.dispatch(setRecordingErrorView(false));
};
